import { render, staticRenderFns } from "./contentCourseLectureExam.vue?vue&type=template&id=0feb7bc7&"
import script from "./contentCourseLectureExam.vue?vue&type=script&lang=js&"
export * from "./contentCourseLectureExam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports